import React, { useState } from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { AiOutlineRight } from "react-icons/ai";
import { useNavigate } from "react-router";
import GoalsOfUser from "./Components/UserGoals/GoalsOfUser";
import { CircularProgress } from "@mui/material";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import {
  setDateFilter,
  setQuarter,
  setQuarterYear,
} from "src/redux/slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import { PieChart } from "react-minimal-pie-chart";

type Props = {
  setStartDate: any;
  isLoading: boolean;
  startDate: any;
  financeData: any;
  totalPendingCount: any;
  batchData: any;
  dashboarGoaldData: any;
  goalsLoading: any;
  goalsIsFetching: any;
  profitLossReportData: any
};

const IncomeExpensesCard = ({ percentage, title, isRevenue }: any) => {
  const arrowIcon = isRevenue ? '▲' : '▼';
  const arrowColor = isRevenue ? 'text-green-500' : 'text-red-500';
  return (
    <div className="">
      <div className={`text-2xl font-bold ${arrowColor} flex items-center`}>
        <span className="mr-2">{arrowIcon}</span>
        <span>{percentage}</span>
      </div>
      {/* <div className="text-gray-500">{title}</div> */}
    </div>
  );
};

const Dashboard = ({
  setStartDate,
  isLoading,
  startDate,
  financeData,
  totalPendingCount,
  batchData,
  dashboarGoaldData,
  goalsLoading,
  goalsIsFetching,
  profitLossReportData
}: Props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch()

  const {
    dateFilter,
    quarterYear,
    quarter,
  } = useSelector((state: RootState) => state.dashboard);
  const [dateFilterGroup, setDateFilterGroup] = useState<any>({
    label: 'Custom range ',
    value: 'DATE_RANGE',
  },)

  const finalAmount = parseInt(profitLossReportData?.totalIncome) || parseInt(profitLossReportData?.totalExpense) ? parseInt(profitLossReportData?.totalIncome) - parseInt(profitLossReportData?.totalExpense) : 0


  const chartData = [
    { title: "Expense", value: profitLossReportData?.totalExpense, color: "#b54747" },
    { title: "Income", value: profitLossReportData?.totalIncome || 0, color: "#1b8040" },
  ];

  return (
    <SideNavLayout>
      <div className="py-3 text-2xl font-medium text-center text-primary-main">
        Geeksdoor ERP
      </div>
      {isLoading ? (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="grid gap-6 p-4 xl:grid-cols-3 lg:grid-cols-2 xs:grid-cols-1">
            <div className="flex flex-col gap-3">
              {/* Pending FollowUps */}
              <div>
                <div className="p-5 rounded-md shadow-md bg-slate-50">
                  <h3 className="text-sm font-medium text-primary-dark">
                    Pending FollowUps
                  </h3>
                  <div className="pt-2 text-4xl font-semibold text-primary-dark">
                    {totalPendingCount || 0}
                  </div>
                  <button
                    onClick={() => navigate(`/pending-followups`)}
                    className="flex pt-2 text-base font-semibold "
                  >
                    <div className="text-primary-light">MORE INFO </div>
                    <div className="pt-1 pl-2 ">
                      <AiOutlineRight />
                    </div>
                  </button>
                </div>
              </div>
            </div>
            {/*Active Batch */}
            <div>
              <div className="p-5 rounded-md shadow-md bg-slate-50">
                <h3 className="text-sm font-medium text-primary-dark">
                  Batches
                </h3>
                <div className="pt-2 text-4xl font-semibold text-primary-dark">
                  {batchData?.totalBatch || 0}
                </div>
                <button
                  onClick={() => navigate(`/batches`)}
                  className="flex pt-2 text-base font-semibold "
                >
                  <div className="text-primary-light">MORE INFO </div>
                  <div className="pt-1 pl-2 ">
                    <AiOutlineRight />
                  </div>
                </button>
              </div>
            </div>
            {/*Student*/}
            <div>
              <div className="p-5 rounded-md shadow-md bg-slate-50">
                <h3 className="text-sm font-medium text-primary-dark">
                  Students
                </h3>
                <div className="pt-2 text-4xl font-semibold text-primary-dark">
                  {batchData?.totalStudent || 0}
                </div>
                <button
                  onClick={() => navigate(`/student`)}
                  className="flex pt-2 text-base font-semibold "
                >
                  <div className="text-primary-light">MORE INFO </div>
                  <div className="pt-1 pl-2 ">
                    <AiOutlineRight />
                  </div>
                </button>
              </div>
            </div>
          </div>


          <div className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-12">
            {/* <div className="col-span-1 sm:col-span-1 md:col-span-3 lg:col-span-4">
              <FinanceSummary
                setStartDate={setStartDate}
                startDate={startDate}
                financeData={financeData}
              />
            </div> */}
            <div className="col-span-1 sm:col-span-1 md:col-span-3 lg:col-span-4 p-2 px-4 rounded-lg shadow-lg h-fit">
              <div className="flex justify-between items-center">
                <div className="font-semibold text-[20px] text-primary-dark">
                  Finance Summary
                </div>
                <div className="my-2 w-[250px]">
                  <ATMSelect
                    name=""
                    label=""
                    size="small"
                    required={false}
                    value={dateFilterGroup}
                    options={[
                      {
                        label: 'Custom range',
                        value: 'DATE_RANGE',
                      },
                      {
                        label: 'Quartly',
                        value: 'QUARTLY',
                      }
                    ]}
                    onChange={(newValue: any) => {
                      setDateFilterGroup(newValue);
                      dispatch(setDateFilter({ ...dateFilter, startDate: null, endDate: null }));
                      dispatch(setQuarter([]))
                      dispatch(setQuarterYear(null));
                    }}
                  />
                </div>
              </div>
              {dateFilterGroup?.value === 'DATE_RANGE' ?
                <div className="flex gap-4">
                  <div className="py-1">
                    <ATMDatePicker
                      label="Start Date"
                      name=""
                      size='small'
                      format="DD/MM/YYYY"
                      value={dateFilter.startDate}
                      onChange={(newValue) => {
                        dispatch(setDateFilter({ ...dateFilter, startDate: newValue }));
                      }}
                    />
                  </div>
                  <div className="py-1">
                    <ATMDatePicker
                      label="End Date"
                      name=""
                      size='small'
                      format="DD/MM/YYYY"
                      value={dateFilter.endDate}
                      onChange={(newValue) => {
                        dispatch(setDateFilter({ ...dateFilter, endDate: newValue }));
                      }}
                    />
                  </div>
                </div>
                :
                <div className="flex gap-4">
                  <ATMMultiSelect
                    name=""
                    size='small'
                    value={quarter}
                    label="Quarter"
                    placeholder="Quarter"
                    // isLoading={isCodioticUserDataLoading}
                    onChange={(newValue) => {
                      dispatch(setQuarter(newValue))
                    }}
                    options={[
                      {
                        label: "1",
                        value: 1
                      },
                      {
                        label: "2",
                        value: 2
                      },
                      {
                        label: "3",
                        value: 3
                      },
                      {
                        label: "4",
                        value: 4
                      },
                    ]}
                  />
                  <div className="">
                    <ATMDatePicker
                      views={['year']}
                      label="Year"
                      size='small'
                      name=""
                      format="YYYY"
                      value={quarterYear}
                      onChange={(newValue) => {
                        dispatch(setQuarterYear(newValue));
                      }}
                    />
                  </div>
                </div>}

              <div className="w-[300px] m-0 p-0 h-[300px] relative">
                <div className="absolute -right-48 top-4">
                  <IncomeExpensesCard
                    percentage={finalAmount ? finalAmount : 0}
                    isRevenue={finalAmount >= 0 ? true : false}
                  />
                </div>
                {profitLossReportData?.totalIncome || profitLossReportData?.totalExpense ?
                  <PieChart
                    animate
                    animationDuration={500}
                    animationEasing="ease-out"
                    center={[50, 50]}
                    viewBoxSize={[90, 90]}
                    data={chartData}
                    labelPosition={68}
                    lengthAngle={360}
                    lineWidth={50}
                    paddingAngle={0}
                    radius={30}
                    startAngle={0}
                    className=""
                  /> :
                  <div className="ml-5">
                    <img height={200} src="/piechartnodata.jpg" alt='no data found' />
                  </div>
                }
              </div>
              <div className="font-semibold text-[16 px]">
                Total Income : <span className="text-green-600"> &#8377; {profitLossReportData?.totalIncome || 0} </span>{" "}
              </div>
              <div className="font-semibold text-[16 px]">
                Total Expense :{" "}
                <span className=" text-red-600 "> &#8377; {profitLossReportData?.totalExpense || 0}</span>{" "}
              </div>
            </div>
            <div className="col-span-1 sm:col-span-1 md:col-span-3 lg:col-span-8 overflow-y-auto max-h-[470px]">
              <GoalsOfUser
                goalsData={dashboarGoaldData}
                isGoalsDataFetching={goalsIsFetching}
                isGoalsDataLoading={goalsLoading}
              />
            </div>
          </div>
        </>
      )}
    </SideNavLayout>
  );
};

export default Dashboard;
